module.exports = __webpack_public_path__ + "static/media/iamcstlouis-project.b94af684.png";